module.exports = __webpack_public_path__ + "menu_2_active_pc.1786793e.png";